module.exports = __webpack_public_path__ + "img/logo.10cb2e84.png";